import { createSlice } from "@reduxjs/toolkit";
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import { IResourceLink } from "../../interfaces/resource-link.interface";

interface ResourceLinksState {
    getResourceLinks: {
        data: IResourceLink[] | undefined;
        loading: boolean;
        success: boolean;
        error: boolean;
    };
}

const initialState: ResourceLinksState = {
    getResourceLinks: {
        data: undefined,
        loading: false,
        success: false,
        error: false,
    },
};

const resourceLinksSlice = createSlice({
    name: "resourceLinks",
    initialState,
    reducers: {
        getResourceLinks(state) {
            state.getResourceLinks = {
                data: undefined,
                loading: true,
                success: false,
                error: false,
            };
        },
        getResourceLinksSuccess(state, actions) {
            state.getResourceLinks = {
                data: actions.payload,
                loading: false,
                success: true,
                error: false,
            };
        },
        getResourceLinksFailure(state) {
            state.getResourceLinks = {
                data: undefined,
                loading: false,
                success: false,
                error: true,
            };
        },
    },
});

export const {
    getResourceLinks,
    getResourceLinksSuccess,
    getResourceLinksFailure,
} = resourceLinksSlice.actions;

export const mapDispatchToProps = () => {
    return bindActionCreators({ getResourceLinks }, useDispatch());
};

export default resourceLinksSlice.reducer;
